module.exports = __webpack_public_path__ + "static/media/thankyou_evaluate.e4888cbc.png";